module.exports = __webpack_public_path__ + "img/play.04d40463.png";